/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~bookwormgb/util/range'

class ProductsSimplePlaceholder extends Component {

	render() {
		const {
			design = 'grid',
			columns = 3,
			limit = 3,
			placeholder = 0,
			showImage = true,
			showProductFormat = true,
			showProductTitle = true,
			showProductAuthor = true,
			showProductPrice = true,
			showAddToCart = true,
			showCompare = true,
			showWishlist = true,
		} = this.props

		const output = (
			<ul className={ classnames( [
				'products',
				'list-unstyled',
				'row', 
				'no-gutters',
				'row-cols-2',
				`row-cols-lg-${columns}`,
				`row-cols-wd-${columns}`,
				'border-top',
				'border-left',
				'mb-6',
				'bookwormgb-products-placeholder-block'
			], {} ) }>
				{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
					return(
						<li className="product bookwormgb-products-placeholder" key={ `product-${i}` }>
							<div className="product__inner overflow-hidden p-3 p-md-4d875">
								{ design === 'grid' ?
									<div className="d-block position-relative">
										{ showImage &&
											<div className="progress bg-light mb-2" style={ { height:'200px' } }></div>
										}
										{ showProductFormat &&
											<div className="badge badge-shadow w-50">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductTitle &&
											<div className="badge badge-shadow w-80">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductAuthor &&
											<div className="badge badge-shadow w-50 d-block">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductPrice &&
											<div className="badge badge-shadow w-50">
												<div className="progress bg-light"></div>
											</div>
										}
									</div>
								:
									<div className="row position-relative">
										{ showImage &&
											<div className="col-md-auto woocommerce-loop-product__thumbnail mb-3 mb-md-0">
												<div className="progress bg-light mb-2" style={ { width:'150px', height:'150px' } }></div>
											</div>
										}
										<div className="col-md woocommerce-loop-product__body product__body pt-3 bg-white mb-3 mb-md-0">
											{ showProductFormat &&
												<div className="badge badge-shadow w-50">
													<div className="progress bg-light"></div>
												</div>
											}
											{ showProductTitle &&
												<div className="badge badge-shadow w-80">
													<div className="progress bg-light"></div>
												</div>
											}
											{ showProductAuthor &&
												<div className="badge badge-shadow w-50 d-block mb-2">
													<div className="progress bg-light"></div>
												</div>
											}
											{ showProductPrice &&
												<div className="badge badge-shadow w-50">
													<div className="progress bg-light"></div>
												</div>
											}
										</div>
										{ ( showAddToCart || showCompare || showWishlist ) &&
											<div className="col-md d-flex align-items-center justify-content-end">
												<div className="badge badge-shadow w-50">
													<div className="progress bg-light"></div>
												</div>
											</div>
										}
									</div>
								}
							</div>
						</li>
					)
				} ) }
			</ul>
		)

		return output
	}
}

export default ProductsSimplePlaceholder